import { useQuery } from '@tanstack/react-query';

import type { IncidentType } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';
import processIncidentApiData from '@/utils/helpers/process-incident-api-data';

const getIncidentsByLineNumber = async (lineNumber: string, selectedDate?: string | null) => {
  const { data } = await axiosInstance.get<IncidentType[]>(
    API_ROUTES.incidentsByLineNumber(lineNumber),
    {
      params: {
        journey_date: selectedDate,
      },
    }
  );

  return processIncidentApiData(data);
};

export const useGetIncidentsByLineNumber = (
  lineNumber?: string | null,
  selectedDate?: string | null
) => {
  return useQuery<IncidentType[]>({
    queryKey: ['incidents', 'route', lineNumber],
    queryFn: () => getIncidentsByLineNumber(lineNumber!, selectedDate),
    enabled: !!lineNumber,
    staleTime: 60 * 60 * 1000,
  });
};
